import React from "react"
import { socialLinks, socialItem } from "./social-medias.module.scss"
import { StyledLink } from "./social-medias-styled"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"

const SocialMedias = ({ iconSize }) => {
  const buildInfos = useBuildData().site_settings
  const tabIcon = {
    facebook: buildInfos.facebook_url,
    instagram: buildInfos.instagram_url,
    twitter: buildInfos.twitter_url,
    youtube: buildInfos.youtube_url,
    linkedin2: buildInfos.linkedin_url,
  }
  return (
    <ul className={socialLinks}>
      {Object.keys(tabIcon).map((socialIconName) => (
        <React.Fragment key={socialIconName}>
          {tabIcon[socialIconName] && (
            <li className={socialItem}>
              <StyledLink
                aria-label={`Suivez nous sur ${socialIconName}`}
                target="_blank"
                rel="noopener noreferrer"
                href={tabIcon[socialIconName]}
              >
                <Icon size={iconSize} icon={socialIconName} />
              </StyledLink>
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  )
}

//-----------------------Prop-Types---------------------------//

SocialMedias.propTypes = {
  iconSize: PropTypes.number,
}
SocialMedias.defaultProps = {
  iconSize: 20,
}
//-----------------------Prop-Types---------------------------//

export default SocialMedias
